/* eslint-disable camelcase */
import ConstructorioClient from '@constructor-io/constructorio-client-javascript';
import {userSegments} from './segments';

const hashedUserId = window.mivaJS?.HashedUserId;

const constructorio = new ConstructorioClient({
	apiKey: window.CONSTRUCTOR_INDEX_KEY,
	sendTrackingEvents: true,
	...hashedUserId ? {userId: String(hashedUserId)} : {},
	...window.CONSTRUCTOR_SERVICE_URL
		? {
			serviceUrl: window.CONSTRUCTOR_SERVICE_URL
		}
		: {}
});

/**
 * Read once, at page load: the router rewrites the query string as filters change.
 */
const segments = userSegments();

/**
 * `constructorio.browse.getBrowseResults()`, with the user segments (`us`) on
 * the request. Segments are the only thing this sends them on: the SDK takes
 * them as a client-wide option rather than per call, so they're set for the
 * call and cleared straight after -- safe because the SDK builds the request
 * URL synchronously, before it returns the promise.
 *
 * @param {Parameters<typeof constructorio.browse.getBrowseResults>} args
 * @returns {ReturnType<typeof constructorio.browse.getBrowseResults>}
 */
const getBrowseResults = (...args) => {
	if (!segments.length) {
		return constructorio.browse.getBrowseResults(...args);
	}

	constructorio.setClientOptions({segments});

	try {
		return constructorio.browse.getBrowseResults(...args);
	}
	finally {
		constructorio.setClientOptions({segments: []});
	}
};

export {constructorio, getBrowseResults};
